import type { WbsClient } from '@bldsoft/cappie/api/wbs'
import type { API, GenericApiResponse, Session } from '@setplex/tria-api'
import type { AdapterDefaults } from './index.h'

import { ensureOk } from '@bldsoft/cappie/rest'

export type SignInParams = {
  username?: string
  password?: string
  rememberMe?: boolean
  model?: string
  foreignPlatformAccessToken?: string
}

export function use(
  client: WbsClient,
  session: API['session'],
  _api: API,
  _defaults: AdapterDefaults
): void {
  // login request
  session.signInFx.use(async ({ username, ...params }: SignInParams) => {
    const ok = await ensureOk(
      client.post.auth({
        body: {
          email: username, // field is called `email` by historical reasons
          manualProfileManagement: true, // prevents automatic profile creation on the backend
          ...params,
        },
        headers: {
          'MW-Paid-Content-Allowed': 'true',
          'MW-InApp-Subscription-Payment-Supported': 'true',
        },
      })
    )
    return ok.body as GenericApiResponse<Session>
  })

  // guest login request
  session.guestInFx.use(async () => {
    const ok = await ensureOk(client.post.auth.guest())
    return ok.body as GenericApiResponse<Session>
  })

  // logout request
  session.signOutFx.use(async () => {
    await ensureOk(client.post.logout())
  })
}
